<template>
  <div class="root-view">

    <scroll-to-top></scroll-to-top>

    <div class="container">
      <div role="banner" class="row">
        <div class="col header text-center">
          <img src="../assets/peeract_banner.png" style="width: 100%; height:100%" alt="peeract Banner">
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div style="height: 3rem"></div>

          <p><strong>{{ i18n.title }}</strong></p>
          <p v-html="i18n.promoText1"></p>
          <p v-html="i18n.promoText2"></p>
          <p v-html="i18n.promoText3"></p>
          <p v-html="i18n.promoText4"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as i18n from '@/i18n/root'
import scrollToTop from '@/components/scroll-to-top'

export default {
  name: 'root-view',
  data () {
    return {
    }
  },
  computed: {
    i18n() {
      return i18n[this.$store.state.profile.lang]
    }
  },
  components: {
    scrollToTop
  }
}
</script>

<style scoped>
*:focus {
  outline: 3px dashed deepskyblue;
}

a {
  color: black;
  text-decoration: underline;
}

.sponsor img {
  height: 8rem;
}
</style>
